import { Component } from '@angular/core';

@Component({
  selector: 'my-rep-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'client';
}
